import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // Checkbox beside the card rather than inside it, so the tap targets stay
  // separate. align-items: center keeps the box against a card whose height
  // varies with title wrapping.
  selectableRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },

  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 3fr) minmax(110px, 2fr)',
    columnGap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 0.5),
    textAlign: 'start',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': { borderBottom: 0 }
  },
  primary: { minWidth: 0, overflowWrap: 'anywhere' },
  secondary: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5),
    overflowWrap: 'anywhere'
  }
}))

export default useStyles
